module.exports = __webpack_public_path__ + "img/gl3.fcac0117.jpg";